jQuery(document).ready(function($) {
	// Toggle the mobile menu on click
	$('.menu-icon').on('click', function() {
		$('.nav-menu').toggleClass('show');
	});
});